/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { FormMode } from '@gh/core-ui';
import { Observable, Subject } from 'rxjs';
import { ContainerState } from './container-state';

export class MutablePageState<T> implements ContainerState<T> {

  private _mode: FormMode = FormMode.CreateMode;
  private _dirty = false;
  private _value: any;
  private changes$$ = new Subject<void>();

  constructor(formMode?: FormMode, value?: T) {

    this._mode = formMode || FormMode.ViewMode;
    this._value = value ? value : this._value;
  }

  get submitValue(): T {
    return this._value;
  }

  get value(): T {
    return this._value;
  }

  set value(value: T) {
    console.warn('MutablePageState.value setter was deprecated: use use setValue function instead');
    this.setValue(value);
  }

  get dirty(): boolean {
    return this._dirty;
  }

  set dirty(dirty: boolean) {
    console.warn('MutablePageState.dirty setter was deprecated: use use setDirty function instead');
    this.setDirty(dirty);
  }

  set mode(mode: FormMode) {
    console.warn('MutablePageState.mode setter was deprecated: use use setMode function instead');
    this.setMode(mode);
  }

  get mode(): FormMode {
    return this._mode;
  }

  get createMode(): boolean {
    return this.mode === FormMode.CreateMode;
  }

  get editMode(): boolean {
    return this.mode === FormMode.EditMode;
  }

  get editable(): boolean {
    return this.createMode || this.editMode;
  }

  get viewMode(): boolean {
    return this.mode === FormMode.ViewMode;
  }

  get invalid(): boolean {
    return false;
  }

  get pending(): boolean {
    return false;
  }

  get changes(): Observable<void> {
    return this.changes$$.asObservable();
  }

  build(..._args: any[]): void {
    // nothing to do
  }

  setDirty(dirty: boolean = true): void {
    if (this._dirty !== dirty) {
      this._dirty = dirty;
      this.emitChange();
    }
  }

  resetDirty(): void {
    this.setDirty(false);
  }

  setMode(mode: FormMode): void {
    this._mode = mode;
  }

  setValue(value: T): void {
    this._value = value;
    this.emitChange();
  }

  emitChange(): void {
    this.changes$$.next();
  }
}
